<div class="astral-stack-l" [formGroup]="form">
  <section class="astral-section-surface">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls.dhMarketRequirementProfile" [itemsSource]="marketOptions.requirementProfiles"></astral-select>
      @if (canSendSubscriptions) {
        <astral-toggle [control]="form.controls.marketSendSubscriptions"></astral-toggle>
      }
      @if (allowBoplatsSverigePublish) {
        <astral-toggle [control]="form.controls.marketPublishToBoplatsSverige"></astral-toggle>
      }
    </astral-layout-group>
  </section>

  @if (form.controls.marketPublishToBoplatsSverige.value && missingBoplatsSverigePublishFields.length) {
    <section class="astral-section-surface astral-section-surface--nested astral-stack-s">
      <div>{{ 'LETTING.ADVERTISMENT.BOPLATS_SVERIGE.MISSING_OBJECT_FIELDS' | translate }}</div>
      <ul>
        @for (field of missingBoplatsSverigePublishFields; track field) {
          <li>{{ field | translate }}</li>
        }
      </ul>
    </section>
  }

  <section class="astral-section-surface astral-stack-m">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-date-picker [control]="form.controls.vacancyFrom"></astral-date-picker>
      <astral-date-picker [control]="form.controls.vacancyTo"></astral-date-picker>
      <app-date-time-picker [control]="form.controls.publishFrom"></app-date-time-picker>
      <app-date-time-picker [control]="form.controls.publishTo"></app-date-time-picker>
      <app-money-box [control]="form.controls.monthlyRent"></app-money-box>
      <app-money-box [control]="form.controls.yearlyRent"></app-money-box>
      <astral-select
        [control]="form.controls.monthsWithRent"
        [itemsSource]="monthSelection"
        [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.CHARGED_MONTHS'"
        [multiple]="true"
      ></astral-select>
    </astral-layout-group>
  </section>

  @if (marketOptions.isShowingEnabled) {
    <section class="astral-section-surface astral-stack-l">
      <h5 class="astral-section-heading">{{ 'LETTING.ADVERTISMENT.DHMARKET.SHOWING' | translate }}</h5>

      @if (tenantSelection?.length) {
        <div class="astral-form-stack">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select [control]="form.controls.showingTenantId" [itemsSource]="tenantSelection"></astral-select>
            @if (form.controls.showingTenantId.value | executeFunc: getTenant; as tenant) {
              <app-text-box-readonly caption="COMMON.EMAIL_ADDRESS" fieldType="email" [text]="tenant.email"></app-text-box-readonly>
              <app-text-box-readonly caption="COMMON.PHONE_NUMBER" fieldType="phone" [text]="tenant.phone"></app-text-box-readonly>
              <app-text-box-readonly
                caption="LETTING.ADVERTISMENT.DHMARKET.SHOWING_CURRENT_UNTIL"
                [text]="tenant.leaseEndDate"
              ></app-text-box-readonly>
            }
          </astral-layout-group>
          @if (form.controls.showingTenantId.value) {
            <astral-textarea [control]="form.controls.showingTenantText"></astral-textarea>
          }
        </div>
      }

      <div class="astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <app-autocomplete-remote-paged
            [control]="form.controls.showingOrdinaryId"
            [defaultSearch]="'*'"
            [service]="ordinaryService"
            (itemSelected)="ordinaryChanged($event)"
          ></app-autocomplete-remote-paged>
          @if (selectedOrdinary) {
            <app-text-box-readonly caption="COMMON.EMAIL_ADDRESS" fieldType="email" [text]="selectedOrdinary.email"></app-text-box-readonly>
            <app-text-box-readonly caption="COMMON.PHONE_NUMBER" fieldType="phone" [text]="selectedOrdinary.phone"></app-text-box-readonly>
          }
        </astral-layout-group>
        @if (form.controls.showingOrdinaryId.value) {
          <astral-textarea [control]="form.controls.showingOrdinaryText"></astral-textarea>
        }
      </div>
    </section>
  }

  <letting-feature-control
    [availableFeatures]="letting.availableLettingFeatures"
    [includedControl]="form.controls.includedLettingFeatureIds"
    [notIncludedControl]="form.controls.notIncludedLettingFeatureIds"
  ></letting-feature-control>

  <section class="astral-section-surface astral-stack-m">
    <letting-translation-control [control]="form.controls.objectDescription" type="area"></letting-translation-control>
    @if (!readonly) {
      <astral-checkbox [control]="form.controls.uniqueObjectDescription"></astral-checkbox>
    }
  </section>
</div>
